module.exports = __webpack_public_path__ + "static/media/camozziProduct.65e86138.jpg";